import * as React from 'react';
import { TabPanel } from 'react-tabs';

import hoistNonReactStatics from 'hoist-non-react-statics';

import { styled } from '../theme';

const TabsPanel = styled(TabPanel)(({ theme }) => ({}));

export default hoistNonReactStatics(TabsPanel, TabPanel);
